module.exports = __webpack_public_path__ + "img/ws.e64f0e0c.svg";